// The name of the cookie we drop in the browser to create a persistent user session
const AUTHENTICATION_COOKIE = 'APIAUTH'

// This is used to verify the authenticity of a request for xsrf attacks.
const XSRF_COOKIE = 'XSRF-TOKEN'

// JSON string to override specific feature flags (used in automated tests)
const FEATURE_FLAG_OVERRIDES = 'FEATURE-FLAG-OVERRIDES'

// This is the id we use to represent a session for unauthenticated users
const ANONYMOUS_SESSION_COOKIE = 'BRID'

module.exports = {
  AUTHENTICATION_COOKIE,
  XSRF_COOKIE,
  FEATURE_FLAG_OVERRIDES,
  ANONYMOUS_SESSION_COOKIE,
}
